import { SVGProps } from 'react'
const SvgBreak = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="5 0 20 21"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M13.5 18.395v-2a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0Zm0-6v-4a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0Zm0-8v-2a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0Z"
    />
  </svg>
)
export default SvgBreak
